import { Html5QrcodeScanner } from 'html5-qrcode';
import { X } from 'lucide-react';
import React, { useEffect, useRef } from 'react';

/**
 * BarcodeScanner - Camera-based scanner using html5-qrcode.
 */
const BarcodeScanner = ({ onScan, onClose }) => {
    const scannerRef = useRef(null);

    useEffect(() => {
        const scanner = new Html5QrcodeScanner(
            "reader", 
            { 
                fps: 10, 
                qrbox: { width: 250, height: 250 },
                aspectRatio: 1.0
            },
            /* verbose= */ false
        );

        scanner.render((decodedText) => {
            onScan(decodedText);
            scanner.clear();
            onClose();
        }, (error) => {
            // silent error to avoid log spamming during scanning search
        });

        return () => {
            scanner.clear().catch(err => console.error("Failed to clear scanner", err));
        };
    }, []);

    return (
        <div className="fixed inset-0 z-[100] bg-primary/95 backdrop-blur-xl flex flex-col items-center justify-center p-6 animate-in fade-in duration-300">
            <button 
                onClick={onClose}
                className="absolute top-8 right-8 p-4 bg-white/10 text-white rounded-2xl hover:bg-white/20 transition-all active:scale-95"
            >
                <X size={24} />
            </button>

            <div className="w-full max-w-sm flex flex-col gap-8">
                <div className="text-center flex flex-col gap-2">
                    <h2 className="text-white font-black text-3xl tracking-tight">Point at Barcode</h2>
                    <p className="text-white/40 font-bold text-sm uppercase tracking-widest leading-relaxed">
                        The system will automatically detect the SKU and close the camera.
                    </p>
                </div>

                <div className="relative">
                    {/* Scanner Container */}
                    <div id="reader" className="overflow-hidden rounded-[3rem] border-4 border-white/10 bg-black/20 shadow-2xl" />
                    
                    {/* Visual Overlay Scan Line */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 border-2 border-accent rounded-3xl opacity-40 pointer-events-none">
                        <div className="absolute top-0 left-0 w-full h-[2px] bg-accent shadow-[0_0_20px_rgba(255,184,0,0.8)] animate-pulse" style={{ top: '50%' }} />
                    </div>
                </div>

                <div className="flex flex-col gap-4 text-center">
                    <div className="flex items-center justify-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                        <span className="text-emerald-500 font-black text-[10px] uppercase tracking-widest">Camera Module Active</span>
                    </div>
                    <p className="text-white/20 text-[9px] font-medium leading-relaxed leading-relaxed font-bold uppercase tracking-widest">
                        Works best with clear lighting and steady hand.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BarcodeScanner;
